module.exports = __webpack_public_path__ + "static/img/top_bg.1981181e.png";